// Donation widget: amount selection, description updates, and hidden amount sync.
// Tab switching (Monthly/Once) is handled by tabs.js via the shared ARIA pattern.
// Each tab panel has its own <form> with its own action URL, so no JS is needed
// for routing — the correct form submits automatically.

document.querySelectorAll('[data-donation-widget]').forEach((widget) => {
  widget.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
    const form = panel.querySelector('form');
    const amountValueInput = panel.querySelector('[data-amount-value]');
    const otherAmountInput = panel.querySelector('[data-other-amount]');
    const descriptionEl = panel.querySelector('[data-amount-description]');
    const amountBtns = Array.from(panel.querySelectorAll('[data-amount-btn]'));
    const minAmount = form?.dataset.minAmount ? parseFloat(form.dataset.minAmount) : null;
    const minAmountError = panel.querySelector('[data-min-amount-error]');
    const otherOptionFaValue = form?.dataset.otherOptionFaValue ?? null;
    const otherAmountFaValueInput = panel.querySelector('[data-other-amount-fa-value]');

    function selectBtn(btn) {
      amountBtns.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      if (descriptionEl) descriptionEl.textContent = btn.dataset.description ?? '';
      if (amountValueInput) amountValueInput.value = btn.dataset.amount;
      if (otherAmountInput) otherAmountInput.value = '';
      if (otherAmountFaValueInput) otherAmountFaValueInput.value = '';
    }

    amountBtns.forEach((btn) => {
      btn.addEventListener('click', () => selectBtn(btn));
    });

    panel.querySelector('[data-message-close]')?.addEventListener('click', () => {
      const bubble = panel.querySelector('[data-bubble-message]');
      if (bubble) bubble.hidden = true;
    });

    otherAmountInput?.addEventListener('input', () => {
      amountBtns.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      if (descriptionEl) descriptionEl.textContent = '';
      if (otherOptionFaValue && otherAmountFaValueInput) {
        if (amountValueInput) amountValueInput.value = otherOptionFaValue;
        otherAmountFaValueInput.value = otherAmountInput.value;
      } else {
        if (amountValueInput) amountValueInput.value = otherAmountInput.value;
      }
    });

    if (minAmount && form) {
      form.addEventListener('submit', (e) => {
        const value = parseFloat(amountValueInput?.value);
        if (!value || value < minAmount) {
          e.preventDefault();
          if (minAmountError) minAmountError.hidden = false;
        } else {
          if (minAmountError) minAmountError.hidden = true;
        }
      });
    }
  });
});
